export const frontConfig = () => {
  const config = JSON.parse(window.appConfig ?? '{}')
  const adminPortalBaseUrl = process.env.REACT_APP_ADMIN_PORTAL_BASE_URL ?? config.ADMIN_PORTAL_BASE_URL
  const themeUrl = process.env.REACT_APP_THEME_URL ?? config.THEME_URL
  const superAdminUsersRaw = process.env.REACT_APP_SUPER_ADMIN_USERS ?? config.SUPER_ADMIN_USERS
  const superAdminUsers = superAdminUsersRaw?.split(',').map((user: string) => user.trim()) ?? []

  return {
    adminPortalBaseUrl,
    themeUrl,
    superAdminUsers,
  }
}
